<template>
    <form method="POST" :action="route" @submit="checkForm">
        <input type="hidden" name="_token" :value="token">
            <div class="row justify-content-center">
                <div class="col-12 mx-auto my-3 pl-4">
                    <p class="fts-18 mb-0 text-left" style="font-weight: 900; color: #262A3E;">Ce que vous vendez</p>
                </div>
                <table name="sell" class="myfotable">
                    <thead>
                        <tr style="background-color: rgba(38, 42, 62, .05);">
                            <th scope="col" style="width: 20%;" class="text-left pl-4">Nom</th>
                            <th scope="col" style="width: 7%;">Contrat</th>
                            <th scope="col" style="width: 8%;">Plateforme</th>
                            <th scope="col" style="width: 8%;">Nombre de parts vendus</th>
                            <th scope="col" style="width: 8%;">Montant(€) vendus</th>
                            <th scope="col" style="width: 8%;">Nouveau montant (€)</th>
                            <th scope="col" style="width: 8%;">Type d'ordre</th>
                            <th scope="col" style="width: 8%;">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(sell, index) in s" :key="index">
                            <td style="width: 20%;"  class="text-left pl-4 font-weight-bold">
                                <div name="name" style="text-transform: uppercase; color: rgb(253, 180, 75);">{{ sell.name }}</div>
                                <div name="isin" class="fts-10" style="color: #6E7389;">Code ISIN : {{ sell.isin }}</div>
                            </td>
                            <td style="width: 7%;">
                                {{ sell.contract }}
                            </td>
                            <td style="width: 8%;">
                                {{ sell.platform }}
                            </td>
                            <td style="width: 8%;">
                                {{ Math.round(sell.change_shares) }}
                                <input
                                    type="number"
                                    style="display:none;"
                                    step="1"
                                    :name="'form[' + sell.id + '][change_number_shares]'"
                                    v-model="sell.change_shares"
                                    @change="onShareChangeSell(sell)">
                            </td>
                            <td style="width: 8%;">
                                {{ Math.round(sell.change_nominal) }}
                                <input
                                    type="number"
                                    style="display: none;"
                                    step="1"
                                    :name="'form[' + sell.id + '][change_nominal_value_base]'"
                                    v-model="sell.change_nominal"
                                    @change="onNominalChangeSell(sell)">
                            </td>
                            <td style="width: 8%;">
                                {{ Math.round(sell.nominal_value_base_rounded) }}
                                <input
                                    type="number"
                                    style="display:none"
                                    step="1"
                                    :name="'form[' + sell.id + '][nominal_value_base_rounded]'"
                                    v-model="sell.nominal_value_base_rounded">
                            </td>
                            <td style="width: 8%;">
                                {{ sell.order_type }}
                            </td>
                            <td style="width: 8%;">
                                <div v-if="sell.transaction_done==0">
                                    <span style="padding: 3px; background-color: rgba(38, 42, 62, .05); color: rgba(38, 42, 62, .5); border-radius: 5px;">Ordre non passé</span>
                                </div>
                                <div v-else>
                                    <span style="padding: 3px; background-color: rgba(19, 178, 44, .1); color: rgb(19, 178, 44); border-radius: 5px;">Ordre passé</span>
                                </div>
                                <input
                                    type="number"
                                    style="display: none;"
                                    step="1"
                                    min="0"
                                    max="1"
                                    :id="'extension_check[' + sell.id + ']'"
                                    :name="'form[' + sell.id + '][transaction_done]'"
                                    v-model="sell.transaction_done">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="row justify-content-center my-3">
                <div class="col-12 mx-auto my-3 pl-4">
                    <p class="fts-18 mb-0 text-left" style="font-weight: 900; color: #262A3E;">Ce que vous achetez</p>
                </div>
                <table name="buy" class="myfotable">
                    <thead>
                        <tr style="background-color: rgba(38, 42, 62, .05);">
                            <th scope="col" style="width: 20%;" class="text-left pl-4">Nom</th>
                            <th scope="col" style="width: 7%;">Contrat</th>
                            <th scope="col" style="width: 8%;">Plateforme</th>
                            <th scope="col" style="width: 8%;">Nombre de parts achetées</th>
                            <th scope="col" style="width: 8%;">Montant (€) acheté</th>
                            <th scope="col" style="width: 8%;">Nouveau montant (€)</th>
                            <th scope="col" style="width: 8%;">Type d'ordre</th>
                            <th scope="col" style="width: 8%;">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(buy, index) in b" :key="index">
                            <td style="width: 20%;" class="text-left pl-4 font-weight-bold">
                                <div name="name" style="text-transform: uppercase; color: #13B22C;">{{ buy.name }}</div>
                                <div name="isin" class="fts-10" style="color: #6E7389;">Code ISIN : {{ buy.isin }}</div>
                            </td>
                            <td style="width: 7%;">
                                {{ buy.contract }}
                            </td>
                            <td style="width: 8%;">
                                {{ buy.platform }}
                            </td>
                            <td style="width: 8%;">
                                {{ Math.round(buy.change_shares) }}
                                <input
                                    type="number"
                                    step="1"
                                    min="0"
                                    style="display:none"
                                    :name="'form[' + buy.id + '][change_number_shares]'"
                                    v-model="buy.change_shares"
                                    @change="onShareChangeBuy(buy)">
                            </td>
                            <td style="width: 8%;">
                                {{ Math.round(buy.change_nominal) }}
                                <input
                                    type="number"
                                    step="1"
                                    min="0"
                                    style="display:none"
                                    :name="'form[' + buy.id + '][change_nominal_value]'"
                                    v-model="buy.change_nominal"
                                    @change="onNominalChangeBuy(buy)">
                            </td>
                            <td style="width: 8%;">
                                {{ Math.round(buy.nominal_value_base_rounded) }}
                                <input
                                    type="number"
                                    step="1"
                                    style="display:none"
                                    :name="'form[' + buy.id + '][nominal_value_base_rounded]'"
                                    v-model="buy.nominal_value_base_rounded">
                            </td>
                            <td style="width: 8%;">
                                {{ buy.order_type }}
                            </td>
                            <td style="width: 8%;">
                                <div v-if="buy.transaction_done==0">
                                    <span style="padding: 3px; background-color: rgba(38, 42, 62, .05); color: rgba(38, 42, 62, .5); border-radius: 5px;">Ordre non passé</span>
                                </div>
                                <div v-else>
                                    <span style="padding: 3px; background-color: rgba(19, 178, 44, .1); color: rgb(19, 178, 44); border-radius: 5px;">Ordre passé</span>
                                </div>
                                <input
                                    type="number"
                                    style="display:none"
                                    step="1"
                                    min="0"
                                    max="1"
                                    :id="'extension_check[' + buy.id + ']'"
                                    :name="'form[' + buy.id + '][transaction_done]'"
                                    v-model="buy.transaction_done">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 mx-auto my-3 pl-4">
                    <p class="fts-18 mb-0 text-left" style="font-weight: 900; color: #262A3E;">Ajustement en cash</p>
                </div>
                <table name="cash" class="myfotable">
                    <thead>
                        <tr style="background-color: rgba(107, 90, 237, .05); color: rgb(107, 90, 237);">
                            <th scope="col" style="width: 25%;">Nom</th>
                            <th scope="col" style="width: 25%;">Contrat</th>
                            <th scope="col" style="width: 25%;">Plateforme</th>
                            <th scope="col" style="width: 25%;">Montant (€)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(cash, index) in c" :key="index">
                            <td style="width: 25%;">
                                {{ cash.sector }}
                            </td>
                            <td style="width: 25%;">
                                {{ cash.contract }}
                            </td>
                            <td style="width: 25%;">
                                {{ cash.platform }}
                            </td>
                            <td style="width: 25%;">
                                {{ cash.nominal_value_base_rounded }}
                                <input
                                    type="number"
                                    style="display: none;"
                                    step="1"
                                    :name="'form[' + cash.id + '][nominal_value_base_rounded]'"
                                    v-model="cash.nominal_value_base_rounded">
                                <input
                                    type="number"
                                    style="display: none;"
                                    step="1"
                                    min="0"
                                    max="1"
                                    value="0"
                                    :id="'extension_check[' + cash.id + ']'"
                                    :name="'form[' + cash.id + '][transaction_done]'">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        <div class="row text-center justify-content-center my-5">
            <button class="btn-myfo-blue" type="submit" :disabled="!valid">Valider</button>
        </div>

    </form>
</template>

<script>
    export default {
        props: [
            'buys',
            'sells',
            'cashs',
            'token',
            'route',
        ],

        data() {
            return {
                form: [],
                errors: [],
                total: 0,
                gap_amount: 0,
                gap_percentage: 0,
                b: [],
                s: [],
                c: [],
                valid: true,

            }
        },

        mounted() {

            this.buys.forEach(buy =>
            {
                this.b.push(
                {
                    arbitrage_show: true,
                    arbitrage_row_span: 1,
                    id: buy.id,
                    name: buy.security.name,
                    isin: buy.security.isin,
                    contract: buy.contract.name,
                    platform: buy.platform.name,
                    previous_number_shares: buy.previous_number_shares,
                    number_shares: buy.number_shares_recommended,
                    change_shares: Math.round(buy.number_shares_recommended*100)/100 - Math.round(buy.previous_number_shares*100)/100,
                    order_type: "Achat",
                    trade_price_local: buy.trade_price_local,
                    nominal_value_base: buy.nominal_value_base_recommended,
                    nominal_value_base_rounded: Math.round(buy.nominal_value_base_recommended * 100) / 100,
                    change_nominal: Math.round(buy.nominal_value_base_recommended * 100) / 100 - Math.round(buy.previous_nominal_value_base * 100) / 100,
                    initial_change_nominal:  Math.round(buy.nominal_value_base_recommended * 100) / 100 - Math.round(buy.previous_nominal_value_base * 100) / 100,
                    initial_change_shares:   Math.round(buy.number_shares_recommended*100)/100 - Math.round(buy.previous_number_shares*100)/100,
                    initial_number_shares: Math.round(buy.number_shares_recommended*100)/100 - Math.round(buy.previous_number_shares*100)/100,
                    initial_nominal_value: buy.nominal_value_base_recommended,
                    transaction_done:0,

                });
            });

            this.sells.forEach(sell =>
            {
                this.s.push(
                {
                    arbitrage_show: true,
                    arbitrage_row_span: 1,
                    id: sell.id,
                    name: sell.security.name,
                    isin: sell.security.isin,
                    contract: sell.contract.name,
                    platform: sell.platform.name,
                    previous_number_shares: sell.previous_number_shares,
                    number_shares: sell.number_shares_recommended,
                    change_shares: Math.round(sell.number_shares_recommended*100)/100 - Math.round(sell.previous_number_shares*100)/100,
                    order_type: "Vente",
                    trade_price_local: sell.trade_price_local,
                    nominal_value_base: sell.nominal_value_base_recommended,
                    nominal_value_base_rounded: Math.round(sell.nominal_value_base_recommended * 100) / 100,
                    change_nominal: Math.round(sell.nominal_value_base_recommended * 100) / 100 - Math.round(sell.previous_nominal_value_base * 100) / 100,
                    initial_change_nominal:  Math.round(sell.nominal_value_base_recommended * 100) / 100 - Math.round(sell.previous_nominal_value_base * 100) / 100,
                    initial_change_shares:   Math.round(sell.number_shares_recommended*100)/100 - Math.round(sell.previous_number_shares*100)/100,
                    initial_number_shares: Math.round(sell.number_shares_recommended*100)/100 - Math.round(sell.previous_number_shares*100)/100,
                    initial_nominal_value: sell.nominal_value_base_recommended,
                    transaction_done:0,
                });
            });

            this.cashs.forEach(cash =>
            {
                this.c.push(
                {
                    arbitrage_show: true,
                    arbitrage_row_span: 1,
                    id: cash.id,
                    name: cash.security.name,
                    isin: cash.security.isin,
                    sector: cash.security.sector.name_french,
                    contract: cash.contract.name,
                    platform: cash.platform.name,
                    nominal_value_base: cash.nominal_value_base_recommended,
                    nominal_value_base_rounded: Math.round(cash.nominal_value_base_recommended * 100) / 100,
                });
            });


            this.total = 0;

            this.b.forEach(buy =>
            {
                this.total += buy.nominal_value_base;
            });

             this.s.forEach(sell =>
            {
                this.total += sell.nominal_value_base;
            });

            this.c.forEach(cash =>
            {
                this.total += cash.nominal_value_base;
            });

            this.total = Math.round(this.total * 100) / 100;

            this.b.forEach(buy =>
            {
                buy.percentage = buy.nominal_value_base / this.total * 100;
                buy.percentage_rounded = Math.round(buy.percentage * 100) / 100;
            });

            this.s.forEach(sell =>
            {
                sell.percentage = sell.nominal_value_base / this.total * 100;
                sell.percentage_rounded = Math.round(sell.percentage * 100) / 100;
            });

            this.c.forEach(cash =>
            {
                cash.percentage = cash.nominal_value_base / this.total * 100;
                cash.percentage_rounded = Math.round(cash.percentage * 100) / 100;
            });



        },

        methods: {

            onShareChangeBuy(buy){
                buy.nominal_value_base_rounded = buy.initial_nominal_value + (buy.change_shares - buy.initial_change_shares)*buy.trade_price_local;
                buy.change_nominal = Math.round(buy.trade_price_local * buy.change_shares * 100) / 100;
                buy.transaction_done = 1;
            },
            onShareChangeSell(sell){
                sell.nominal_value_base_rounded = sell.initial_nominal_value + (sell.change_shares - sell.initial_change_shares)*sell.trade_price_local;
                sell.change_nominal = Math.round(sell.trade_price_local * sell.change_shares * 100) / 100;
                sell.transaction_done = 1;
            },
            onNominalChangeBuy(buy){
                buy.nominal_value_base_rounded = buy.initial_nominal_value + (buy.change_nominal - buy.initial_change_nominal);
                buy.change_shares = Math.round((buy.change_nominal/buy.trade_price_local)* 100) / 100;
                buy.transaction_done = 1;
            },
            onNominalChangeSell(sell){
                sell.nominal_value_base_rounded = sell.initial_nominal_value + (sell.change_nominal - sell.initial_change_nominal);
                sell.change_shares = Math.round((sell.change_nominal/sell.trade_price_local) * 100) / 100;
                sell.transaction_done = 1;
            },


            checkForm(event){
                if (!valid)
                {
                    event.preventDefault()
                }
            }
        }

    }



</script>